// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cfa1b4db","977":"d3cdb528"}[chunkId] + ".chunk.js";
};